<template>
  <el-row :gutter="20">
    <el-col :span="18">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <span>{{ $t('staffDetailInfo.title') }}</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="goBack">
            {{ $t('common.back') }}
          </el-button>
        </div>
        <div class="card-content">
          <el-row>
            <el-col :span="4">
              <el-image style="width: 120px; height: 140px" :src="staffDetailInfo.photo" fit="cover"
                @error="errorLoadImg" class="border-radius"></el-image>
            </el-col>
            <el-col :span="20">
              <el-form :model="staffDetailInfo" label-width="120px" class="text-left">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.staffId')">
                      <span>{{ staffDetailInfo.staffId }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.userName')">
                      <span>{{ staffDetailInfo.userName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.email')">
                      <span>{{ staffDetailInfo.email }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.tel')">
                      <span>{{ staffDetailInfo.tel }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.sex')">
                      <span>{{ staffDetailInfo.sex == '0' ? $t('staffDetailInfo.male') : $t('staffDetailInfo.female')
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('staffDetailInfo.address')">
                      <span>{{ staffDetailInfo.address }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <el-card class="box-card margin-top">
        <div slot="header" class="flex justify-between">
          <span>{{ $t('staffDetailInfo.relatedOrg') }}</span>
        </div>
        <div class="card-content text-left">
          <el-row v-for="(item, index) in staffDetailInfo.orgs" :key="index">
            <el-col :span="12">{{ $t('staffDetailInfo.org') }}：{{ item.orgName }}</el-col>
          </el-row>
        </div>
      </el-card>

      <el-card class="box-card margin-top">
        <div slot="header" class="flex justify-between">
          <span>{{ $t('staffDetailInfo.relatedRoleAndShop') }}</span>
        </div>
        <div class="card-content text-left">
          <el-row v-for="(item, index) in staffDetailInfo.roles" :key="index">
            <el-col :span="24">
              <p v-if="item.roleShopDtoList.length > 0">
                {{ item.roleName }} (
                <span v-for="(item1, index1) in item.roleShopDtoList" :key="index1">
                  {{ item1.shopName }}
                  {{ index1 === item.roleShopDtoList.length - 1 ? " " : " 、 " }}
                </span> )
              </p>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <span>{{ $t('staffDetailInfo.staffPrivilege') }}</span>
        </div>
        <div class="card-content text-left">
          <el-tree :data="privilegeTreeData" :props="defaultProps" node-key="id" default-expand-all
            :expand-on-click-node="false"></el-tree>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getStaffDetail, getStaffOrgs, getStaffRoles, getStaffPrivileges } from '@/api/frame/staffDetail/staffDetailApi'

export default {
  name: 'StaffDetail',
  data() {
    return {
      staffDetailInfo: {
        staffId: '',
        userName: '',
        email: '',
        tel: '',
        sex: '',
        address: '',
        photo: '',
        privileges: [],
        orgs: [],
        communitys: [],
        roles: []
      },
      privilegeTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const staffId = this.$route.query.staffId
      if (!staffId) {
        this.$message.error(this.$t('staffDetailInfo.staffIdRequired'))
        return
      }
      this.staffDetailInfo.staffId = staffId
      this.loadStaffDetail()
      this.loadStaffOrgs()
      this.loadStaffRoles()
      this.loadStaffPrivileges()
    },
    async loadStaffDetail() {
      try {
        const params = {
          page: 1,
          row: 1,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffDetail(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.staffDetailInfo, res.data[0])
          this.staffDetailInfo.photo = res.data[0].faceUrl || '/img/noPhoto.jpg'
        }
      } catch (error) {
        console.error('获取员工详情失败:', error)
      }
    },
    async loadStaffOrgs() {
      try {
        const params = {
          page: 1,
          row: 1,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffOrgs(params)
        this.staffDetailInfo.orgs = res.data || []
      } catch (error) {
        console.error('获取员工组织失败:', error)
      }
    },
    async loadStaffRoles() {
      try {
        const params = {
          page: 1,
          row: 9999,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffRoles(params)
        this.staffDetailInfo.roles = res.data || []
      } catch (error) {
        console.error('获取员工角色失败:', error)
      }
    },
    async loadStaffPrivileges() {
      try {
        const params = {
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffPrivileges(params)
        this.staffDetailInfo.privileges = res.datas || []
        this.privilegeTreeData = this.buildTreeData(res.datas)
      } catch (error) {
        console.error('获取员工权限失败:', error)
      }
    },
    buildTreeData(privileges) {
      const treeData = []
      const groupMap = new Map()

      // 构建组
      privileges.forEach(item => {
        if (!groupMap.has(item.gId)) {
          const groupItem = {
            id: `g_${item.gId}`,
            gId: item.gId,
            text: item.gName,
            children: []
          }
          groupMap.set(item.gId, groupItem)
          treeData.push(groupItem)
        }
      })

      // 构建菜单
      const menuMap = new Map()
      privileges.forEach(item => {
        const groupItem = groupMap.get(item.gId)
        if (groupItem && !menuMap.has(item.mId)) {
          const menuItem = {
            id: `m_${item.mId}`,
            mId: item.mId,
            text: item.mName,
            children: []
          }
          menuMap.set(item.mId, menuItem)
          groupItem.children.push(menuItem)
        }
      })

      // 构建权限
      privileges.forEach(item => {
        const menuItem = menuMap.get(item.mId)
        if (menuItem) {
          menuItem.children.push({
            id: `p_${item.pId}`,
            pId: item.pId,
            text: item.pName
          })
        }
      })

      return treeData
    },
    errorLoadImg() {
      this.staffDetailInfo.photo = '/img/noPhoto.jpg'
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.border-radius {
  border-radius: 4px;
}

.margin-top {
  margin-top: 20px;
}

.card-content {
  padding: 20px;
}
</style>